import "../../icons/atalanda.icon_font";
import "../../fonts/atalanda/fonts.scss";
import "../../store";
